module.exports = "https://cdn.realtymogul.com/static/media/icon_income.e69c0b20.svg";